import { Link, Navigate } from 'react-router-dom';
import AudioToolsPanel from '../components/AudioTools/AudioToolsPanel';

const TOOL_CONTENT = {
  'realtime-speech-to-text': {
    title: 'Realtime Speech to Text',
    description:
      'Transcribe live microphone audio instantly while you speak and watch results update in real time.',
  },
  'speech-to-text': {
    title: 'Speech to Text',
    description: 'Upload audio files and convert spoken words into editable text.',
  },
  'voice-changer': {
    title: 'Voice Changer',
    description: 'Adjust pitch, speed, and gain to transform a voice recording.',
  },
  'text-to-sound-effects': {
    title: 'Text to Sound Effects',
    description: 'Generate downloadable sound effects from text prompts.',
  },
  'voice-isolator': {
    title: 'Voice Isolator',
    description: 'Isolate and enhance vocals from noisy audio recordings.',
  },
};

function AudioToolDashboard({ toolId }) {
  const tool = TOOL_CONTENT[toolId];

  if (!tool) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="mb-6">
        <Link to="/dashboard" className="text-sm text-purple-400 hover:underline">
          ← Back to Dashboard
        </Link>
      </div>

      <div className="mb-2">
        <h1 className="text-3xl font-bold mb-2">{tool.title}</h1>
        <p className="text-gray-400">{tool.description}</p>
      </div>

      <AudioToolsPanel activeSection={toolId} />
    </div>
  );
}

export default AudioToolDashboard;
